import type { AgentCapabilities, ChatSession } from "../../../src/types/index.ts";

type RestoreBackendSessionOptions = {
  session: ChatSession | undefined;
  loadSession: (sessionId: string) => Promise<{ success: boolean }>;
  resumeSession: (sessionId: string) => Promise<{ success: boolean }>;
  newSession: () => Promise<string>;
  getCapabilities: () => Promise<AgentCapabilities>;
  bindSessionId: (id: string, acpSessionId: string) => void;
  id: string;
};

export async function restoreBackendSessionState(
  options: RestoreBackendSessionOptions,
): Promise<{ acpSessionId: string; exact: boolean }> {
  let restoredAcpSessionId = options.session?.acpSessionId || null;
  let restoredExactly = false;
  const caps = await options.getCapabilities();

  if (restoredAcpSessionId && caps.loadSession) {
    const result = await options.loadSession(restoredAcpSessionId);
    if (result.success) {
      restoredExactly = true;
    }
  }

  if (restoredAcpSessionId && !restoredExactly && caps.resume) {
    const result = await options.resumeSession(restoredAcpSessionId);
    if (result.success) {
      restoredExactly = true;
    }
  }

  if (!restoredExactly) {
    restoredAcpSessionId = await options.newSession();
    options.bindSessionId(options.id, restoredAcpSessionId);
  }

  return { acpSessionId: restoredAcpSessionId, exact: restoredExactly };
}
